import AutomationHeaderView from "@/systems/modules/automation/AutomationHeaderView.vue";
import authorization from "@/authorization";
import AutomationRulesView from "@/systems/modules/automation/AutomationRulesView.vue";
import AutomationTemplatesView from "@/systems/modules/automation/templates/AutomationTemplatesView.vue";
import AutomationLogsView from "@/systems/modules/automation/logs/AutomationLogsView.vue";
import {modules} from "@/systems/modules/modules";

export default {
    getRoutes: () => ([
        {
            name: "community.modules.automation",
            path: "automation",
            component: AutomationHeaderView,
            props: true,
            meta: {
                authorize: () => authorization.moduleEnabled(modules.automation) && authorization.permission("modules.automation.rules.edit"),
            },
            redirect: { name: "community.modules.automation.rules" },
            children: [
                {
                    name: "community.modules.automation.rules",
                    path: "rules",
                    component: AutomationRulesView,
                    props: true
                },
                {
                    name: "community.modules.automation.templates",
                    path: "templates",
                    component: AutomationTemplatesView,
                    props: true
                },
                {
                    name: "community.modules.automation.logs",
                    path: "logs",
                    component: AutomationLogsView,
                    props: true
                }
            ]
        }
    ])
};